import React from 'react';
// import { Link } from 'react-router-dom';

const DonateButton = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children,
  ...props 
}) => {
  const getButtonClasses = () => {
    let classes = 'btn-donate d-inline-flex align-items-center gap-2 text-decoration-none';
    
    if (variant === 'outline') {
      classes += ' btn-donate-outline';
    }
    
    if (size === 'sm') {
      classes += ' btn-donate-sm';
    } else if (size === 'lg') {
      classes += ' btn-donate-lg';
    }
    
    return `${classes} ${className}`;
  };

  return (
    <a 
      href="/donate" 
      className={getButtonClasses()}
      {...props}
    >
      {/* <i className="bi bi-heart-fill"></i> */}
      {children || 'Donate Now'}
    </a>
  );
};

export default DonateButton;